import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface HoverArrowProps {
    className?: string
    direction?: 'left' | 'right'
}

// Chevron that grows a tail when its parent button (group/button) is hovered or focused.
export const HoverArrow: FC<HoverArrowProps> = ({ className, direction = 'right' }): ReactNode => {
    return (
        <svg
            className={cn(
                'relative top-px size-2.5 shrink-0 fill-none stroke-current stroke-2',
                direction === 'left' && 'rotate-180',
                className
            )}
            viewBox='0 0 10 10'
            aria-hidden='true'
            focusable='false'
        >
            <path
                className='opacity-0 transition-opacity duration-150 ease-out group-hover/button:opacity-100 group-focus-visible/button:opacity-100'
                d='M0 5h7'
            />
            <path
                className='transition-transform duration-150 ease-out group-hover/button:translate-x-[3px] group-focus-visible/button:translate-x-[3px]'
                d='M1 1l4 4-4 4'
            />
        </svg>
    )
}
